import { Labels } from '../../shared-components/global/labels';

Labels.set('validation', 'input', 'Palun sisesta korrektsed andmed.');
Labels.set('validation', 'date', 'Palun sisesta korrektsed andmed.');
Labels.set('validation', 'time', 'Palun sisesta aeg.');
Labels.set('validation', 'range', 'Viga sisestamisel.');
Labels.set('validation', 'month', 'Palun sisesta kuu.');
Labels.set(
    'validation',
    'datetime-local',
    'Palun sisesta kellaaeg ja kuupäev.'
);
Labels.set('validation', 'custom', 'Viga, palun kontrolli sisestatud andmeid.');
Labels.set('validation', 'pattern', 'Palun sisesta korrektses vormingus.');
Labels.set(
    'validation',
    'rangeOverflow',
    'Väärtus peab olema sama või väiksem kui %s.'
);
Labels.set(
    'validation',
    'rangeUnderflow',
    'Väärtus peab olema sama või suurem kui %s.'
);
Labels.set(
    'validation',
    'step',
    'Samm peab olema %s, lähimad numbrid on %s ja %s.'
);
Labels.set('validation', 'long', 'Väärtus on liiga pikk, max %s sümbolit.');
Labels.set('validation', 'short', 'Väärtus on liiga lühike, min %s sümbolit.');
Labels.set('validation', 'type', 'Palun sisesta korrektsed andmed.');
Labels.set('validation', 'email', 'Palun sisesta e-posti aadress.');
Labels.set('validation', 'url', 'Palun sisesta URL.');
Labels.set('validation', 'value', 'Palun täida see väli.');

// User defined rule validations
Labels.set('validation', 'matches', 'Väljade andmed ei kattu.');
Labels.set('validation', 'checkboxes', 'Palun vali vähemalt %s valik(ut).');
Labels.set('validation', 'remote', 'Serveri viga.');
Labels.set(
    'validation',
    'maxfilesize',
    'Faili(-de) suurus on suurem kui %s Kb.'
);
Labels.set(
    'validation',
    'requiredMultiple',
    'Palun täitke vähemalt %s väli(-ja).'
);

// Example formats for pattern rule
Labels.set('validation', 'basicDateFormat', 'DD.MM.YYYY');
Labels.set(
    'validation',
    'alternativeDateFormat',
    'DD.MM.YYYY või D.M.YYYY või D.MM.YYYY'
);
Labels.set('validation', 'reverseDateFormat', 'YYYY.MM.DD');
Labels.set('validation', 'basicTimeFormat', 'HH:MM:SS');
Labels.set('validation', 'shortTimeFormat', 'HH:MM');
Labels.set('validation', 'digitsAmountFormat', '%s arvu.');
Labels.set('validation', 'digitsAmountHardcodedFormat', '13–16 arvu.');
Labels.set('validation', 'lettersAndNumbersFormat', 'Tähed ja numbrid.');
Labels.set('validation', 'lettersOnlyFormat', 'Ainult tähed.');
Labels.set('validation', 'numbersOnlyFormat', 'Ainult numbrid.');
Labels.set(
    'validation',
    'decimalPointNumbersFormat',
    'Numbrid komakohaga, näiteks 9.99 või 9,99.'
);
Labels.set(
    'validation',
    'startingDateBeforeEndingDate',
    'Algusaeg peab eelnema lõpuajale.'
);
